import Modal from "./Modal/Modal";
import React from "react";
import { useApp } from "../contexts";
import styled from "styled-components";
import { Divider } from "antd";
import FormButton from "./FormCustom2/Button";
const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalMintNotify = ({ value, ...props }) => {
  const { T } = useApp();
  const { buttonText, onClose, onSubmit, isLoading } = props; 

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2 width="850px" className={'modal-mint'} onClose={onClose}>
        <ContentWaper>
          <div className="text-black text-center font-semibold text-[24px] xls:text-[30px] tracking-[-0.96px] lg:h-full">
            {props?.title}
          </div>
          <div className="mt-[10px] lg:mt-[10px]">
            <div>
              <div className="mt-[20px] text-[14px] md:text-[16px] lg:mt-[20px]  justify-center text-center items-center text-black text-base leading-[26px]"
                dangerouslySetInnerHTML={{
                __html: T(props?.des),
                }}
              ></div>
              {/* <div className="mt-[20px] text-[14px] md:text-[16px] lg:mt-[20px] flex justify-center text-center items-center text-black text-base leading-[26px]">
                {props?.des}
              </div> */}
              <Divider className="my-[40px] xls:my-[40px] hidden md:block" />
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap flex-col-reverse md:flex-row md:flex-nowrap justify-center items-center gap-[20px]">
                  <button type="button"
                    disabled={isLoading}
                    className="bg-black leading-[52px] !text-white rounded-[15px] min-w-[231px] px-[20px] h-[52px]"
                    onClick={() => onSubmit()}
                  >
                  {T(buttonText)}
                  </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
